import english from "assets/flags/english.svg";
import french from "assets/flags/french.svg";
import german from "assets/flags/german.svg";
import italian from "assets/flags/italian.svg";
import japanese from "assets/flags/japanese.svg";
import korean from "assets/flags/korean.svg";
import portuguese from "assets/flags/portuguese.svg";
import russian from "assets/flags/russian.svg";
import swedish from "assets/flags/swedish.svg";
import spanish from "assets/flags/spanish.svg";

export const flags: any = {
  english,
  french,
  german,
  italian,
  japanese,
  korean,
  portuguese,
  russian,
  swedish,
  spanish,
};
